(function($) {

  // toggle elements based on data-toggle attribute
  $('.js-toggle').click(function() {
    var toggleData = $(this).attr('data-toggle');
    $(".js-toggle-receiver[data-toggle="+toggleData+"]").toggleClass("active");
  });

})(jQuery);